import type * as actions from '../actions'
import type { Feature } from '../feature'

/**
 * TODO:
 *
 * Producer can optionally return `undefined` to allow for effects that should
 * only be conditionally registered
 */
// NOTE 1: this is not in any namespace, as it is more discoverable at the top
// level
// NOTE 2: while we are not currently using generics in the return type here,
// this is still intentionally missing a return type in case we need generics
// in the future. Based on this:
// https://github.com/microsoft/TypeScript/issues/37835#issuecomment-638624108
export function extra<
  TFeature extends Feature.Constraint,
  TArgs extends readonly unknown[],
  TActionFilters extends readonly actions.Filter<actions.Action.Constraint>[],
>(
  producer: (
    feature: TFeature,
    ...args: TArgs
  ) => ReturnType<ExtraReducer.Registrator<TFeature, TActionFilters>>,
) {
  return (...args: TArgs) =>
    ((feature: TFeature) =>
      producer(feature, ...args)) satisfies ExtraReducer.Registrator<
      TFeature,
      TActionFilters
    >
}

/**
 * TODO:
 */
export class ExtraReducer<
  TState = unknown,
  TActionFilters extends
    readonly actions.Filter<actions.Action.Constraint>[] = readonly actions.Filter<actions.Action.Constraint>[],
> {
  /** TODO:  */
  public readonly on: Readonly<TActionFilters>
  /** TODO:  */
  public readonly reduce: ExtraReducer.Callback<TState, TActionFilters>

  constructor({
    on,
    reduce,
  }: ExtraReducer.constructor.Params<TState, TActionFilters>) {
    this.on = on
    this.reduce = reduce
  }
}
export namespace ExtraReducer {
  export namespace constructor {
    export interface Params<
      TState = unknown,
      TActionFilters extends
        readonly actions.Filter<actions.Action.Constraint>[] = readonly actions.Filter<actions.Action.Constraint>[],
    > {
      on: TActionFilters
      reduce: Callback<TState, TActionFilters>
    }
  }

  export interface Binding<
    TExtraReducer extends ExtraReducer<any, any> = ExtraReducer,
  > {
    readonly feature: Feature.Constraint
    readonly reducer: TExtraReducer
  }

  /**
   * Used with {@link Feature.registerExtraReducers}
   */
  export type Registrator<
    TFeature extends Feature.Constraint,
    TActionFilters extends readonly actions.Filter<actions.Action.Constraint>[],
  > = (
    feature: TFeature,
  ) =>
    | ExtraReducer<
        TFeature extends Feature.Constraint<infer TState> ? TState : never,
        TActionFilters
      >
    | undefined

  // TODO fix state type
  /**
   * TODO: clear up
   *
   * Returns an updated state (for a plugin?)
   */
  export type Callback<
    TState = unknown,
    TActionFilters extends
      readonly actions.Filter<actions.Action.Constraint>[] = readonly actions.Filter<actions.Action.Constraint>[],
  > = (
    state: TState,
    action: ActionFromFilters<TActionFilters>,
    globalState: object,
  ) => TState
}

type ActionFromFilters<
  TActionFilters extends readonly actions.Filter<actions.Action.Constraint>[],
> = TActionFilters extends readonly actions.Filter<infer TAction>[]
  ? TAction
  : never
